export default {
  state: {
    list: [],
    search: "",
    order: "id",
    orderAsc: 1,
    currentPage: 1,
    perPage: 20,
    status: "active",
    loading: false,
    maxList: 0,
    showForm: false,
    edit: {},
    permissions: {},
    reportPermissions: {},
    addSuccess: false,
    accessList: {
      PageAdminDashboard: "Providers Page - View",
      PageAdminProviderEdit: "Providers Page - Edit",
      PageAdminProviderNum: "Providers Page - Vehicle No.",
      PageAdminConsumers: "Consumers Page",
      PageAdminCorporates: "Corporates Page",
      PageAdminTransactions: "Transactions Page",
      PageAdminImport : "Import RSVP",
      PageAdminPromocodes: "Promo Page",
      PageAdminRatings: "Ratings Page",
      PageAdminBids: "Bids Page",
      PageAdminAds: "Ads Page",
      PageAdminFleetReport: "Fleet Page",
      PageAdminLog: "Logs Page",
      PageAdminNotifications: "Notifications Page",
      PageAdminMap: "Map Page",
      PageAdminGeo: "Geofence Page",
      PageAdminPricing: "Pricing Page",
      PageAdminService: "Service Type Page",
      PageAdminSettings: "Settings Page",
      PageAdminStagingLot: "Staging Lot Page",
      PageAdminFilter: "Filter Page",
      PageAdminRSVP: "Reservation Details Page",
      PageAdminRSVPAdd: "Create Reservation",
      PageAdminRSVPEdit: "Edit Reservation",
      PageAdminRSVPWaivePayments: "Waive edit payments",
      PageAdminDispatch: "Dispatch Page",
      PageAdminLaxit: "Laxit Page",
      PageAdminRouting: "Routing Page",
      PageAdminBrands: "Brands Page",
      PageAdminNotes: "Add Notes",
      PageAdminRefund: "Transaction Refund",
      PageAdminPriceOverride: "Price Override",
      PageAdminOverride: "Driver Payment Bonus",
      PageAdminAdmins: "Admin Page",
      PageAdminReports: "Reports",
      PageAdminProviderDeductions: "Provider Deductions",
      PageAdminDriverBatchModifications: "Provider Payouts",
      PageAdminRsvpControl: 'RSVP Control (Complete/No Show)',
      PageAdminCode: 'Admin Code',
      PageAdminInsurance: 'Insurance Page',
      ForceDriverPaymentOverride: 'Force Driver Payment Override'
    },
    reportsList: {
      PageReportsTNCReportForLAWA: 'TNC Report for LAWA',
      PageReportsReservationReports: 'Reservation Reports',
      PageReportsTransactionReports: 'Transaction Reports',
      PageReportsDriverReviews: 'Driver Reviews',
      PageReportsSpecialReports: 'Special Reports',
      PageReportsDirectBill: 'Direct Bill',
      PageReportsPayoutReport: 'Payout Report',
      PageReportsBackendManager: 'Backend Manager',
      PageReportsMTech: 'MTech',
      PageReportsBlockReport: 'Block Report',
      PageReportsTNCReportLongBeach: 'TNC Report - Long Beach',
      PageReportsActiveDrivers: 'Active Drivers',
      PageReportsDriverCount: 'Driver Count',
      PageReportsLyftReport: 'Lyft Report'
    }
  },
  mutations: {
    setList(state, value) {
      state.list = value;
    },
    updateAdminActive(state, data) {
      let index = state.list.findIndex(x => x.id === data.id);
      if (index > -1) {
        state.list[index].isActive = data.isActive;
      }
    },
    setSearch(state, value) {
      state.search = value;
    },
    setOrder(state, value) {
      state.order = value;
    },
    setOrderAsc(state, value) {
      state.setOrderAsc = value;
    },
    setCurrentPage(state, value) {
      state.currentPage = value;
    },
    setPerPage(state, value) {
      state.perPage = value;
    },
    setStatus(state, value) {
      state.status = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setMaxList(state, value) {
      state.maxList = value;
    },
    updatePermission(state, data) {
      if (data.add) {
        let backup = state.permissions;
        state.permissions = {};

        state.permissions = backup;
        state.permissions[data.field] = "view";
      } else {
        let backup = state.permissions;
        state.permissions = {};

        state.permissions = backup;
        if (state.permissions[data.field]) {
          delete state.permissions[data.field];
        }
      }
    },
    setShowForm(state, value) {
      state.showForm = value;
    },
    setEdit(state, data) {
      state.permissions = {}
      state.permissions = Object.assign({}, data.permission)

      state.reportPermissions = {}
      state.reportPermissions = Object.assign({}, data.reportPermissions)
      
      state.edit = data
    },
    setPermissions(state, value) {
      state.permissions = value;
    },
    setAddSuccess(state, value) {
      state.addSuccess = value;
    },
    updateReportPermission(state, data) {
      if (data.add) {
        state.reportPermissions[data.field] = "view"
      } else {
        delete state.reportPermissions[data.field]
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/admin/admin.js